import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/*
 * Renders a role value as human readable.
 * Example:
 *   {{ 'ORG_ADMIN' | role }}
 *   formats to: 'Administrator
 */
@Pipe({
    name: 'role', pure: true,
    standalone: false
})
export class RolePipe implements PipeTransform {
  constructor(public translate: TranslateService) {}
  transform(value: string): string {
    return this.translate.instant(`roles.${value}`);
  }
}
